export default __webpack_public_path__ + "static/media/25-paramount.776912a0.jpg";